/**
 * 播放页展开 morph 期间推迟非关键任务，避免与 GSAP / 首帧渲染争抢主线程
 */
let morphActiveCount = 0;
const pendingTasks = [];

export function isPlayerMorphActive() {
  return morphActiveCount > 0;
}

export function setPlayerMorphActive(active) {
  if (active) {
    morphActiveCount += 1;
    return;
  }
  morphActiveCount = Math.max(0, morphActiveCount - 1);
  if (morphActiveCount === 0) {
    flushPendingTasks();
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('player-open-idle'));
    }
  }
}

/** 播放页展开前调用，避免组件挂载 burst 与 morph 动画争抢主线程 */
export function ensurePlayerMorphActive() {
  if (morphActiveCount === 0) {
    morphActiveCount = 1;
  }
}

export function runWhenPlayerOpenIdle(fn, options = {}) {
  const { timeout = 1500, delayMs = 0 } = options;

  const execute = () => {
    const run = () => {
      try {
        fn();
      } catch (error) {
        console.warn('[playerOpenIdle] 延迟任务执行失败:', error);
      }
    };
    if (delayMs > 0) {
      setTimeout(run, delayMs);
      return;
    }
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(run, { timeout });
    } else {
      setTimeout(run, 280);
    }
  };

  if (morphActiveCount > 0) {
    pendingTasks.push(execute);
    return;
  }
  execute();
}

export function waitForPlayerOpenIdle(options = {}) {
  return new Promise((resolve) => {
    runWhenPlayerOpenIdle(resolve, options);
  });
}

function flushPendingTasks() {
  const tasks = pendingTasks.splice(0);
  tasks.forEach((task, index) => {
    setTimeout(task, 200 + index * 72);
  });
}
